{
  "el": {
    "employee": {
      "actions": {
        "accessProjects": "Διαχείριση πρόσβασης σε έργα",
        "cancel": "Αναίρεση",
        "changeProfilePicture": "Αλλαγή φωτογραφίας προφίλ",
        "change_role": "Αλλαγή ρόλου σε",
        "download": "Λήψη",
        "new": "Μέλος ομάδας",
        "profilePictureFormat": "Πρέπει να είναι τουλάχιστον 300x300px",
        "save": "Αποθήκευση",
        "searchEmployee": "Αναζήτηση μέλους ομάδας",
        "sendinvitation": "Δημιουργία και αποστολή πρόσκλησης",
        "submit": "Αποθήκευση",
        "undoChanges": "Αναίρεση"
      },
      "attributes": {
        "email_address": "Email",
        "email_notifications_interval": {
          "daily": "Μία φορά την ημέρα (γύρω στο μεσημέρι)",
          "hourly": "Κάθε ώρα",
          "twice_daily": "Δύο φορές την ημέρα (πρωί/μεσημέρι)",
          "weekly": "Μία φορά την εβδομάδα (Δευτέρα μεσημέρι)"
        },
        "first_name": "Όνομα",
        "language": "Γλώσσα",
        "last_name": "Επώνυμο",
        "phone_landline": "Αριθμός σταθερού τηλεφώνου",
        "phone_mobile": "Αριθμός κινητού τηλεφώνου",
        "profession": "Επάγγελμα",
        "role": "Δικαιώματα πρόσβασης",
        "signature_html": "Υπογραφή συνομιλιών",
        "status": "Κατάσταση",
        "title": "Τίτλος"
      },
      "integrations": {
        "hide_details": "Απόκρυψη λεπτομερειών",
        "last_synced_at": "Τελευταίος συγχρονισμός: {time}",
        "show_details": "Εμφάνιση λεπτομερειών"
      },
      "labels": {
        "all_projects": "Όλα τα έργα",
        "confirmChangeRoleTitle": "Αλλαγή ρόλου: {role};",
        "confirmChangeRoleToMaintainer": "Σημείωση: {name} θα χάσει την πρόσβαση σε όλα τα έργα και όλες οι υπάρχουσες ειδοποιήσεις θα αφαιρεθούν. Μπορείς να αναθέσεις ξανά {name} σε έργα ως Διαχειριστή έργου αργότερα.",
        "confirmChangeRoleToOwner": "{name} θα αποκτήσει πρόσβαση σε όλα τα έργα και όλο το περιεχόμενο της πλατφόρμας.",
        "confirmPasswordReset": "Στάλθηκε ένα email με σύνδεσμο επαναφοράς του κωδικού πρόσβασής σου. Έλεγξε τα εισερχόμενά σου. Επικοινώνησε μαζί μας αν αντιμετωπίσεις οποιοδήποτε πρόβλημα.",
        "disabled": {
          "access": "Θα δώσουμε πρόσβαση σε όλους τους υπαλλήλους στην πλατφόρμα από τη στιγμή που θα εξοφληθεί το τελευταίο ληξιπρόθεσμο τιμολόγιο.",
          "contact": "Επικοινώνησε μαζί μας",
          "overdue": "Παρατηρήσαμε ότι το τελευταίο σου τιμολόγιο είναι εδώ και καιρό ληξιπρόθεσμο. Ανακαλέσαμε την πρόσβαση όλων των υπαλλήλων σε αυτή την πλατφόρμα. Οι συνεργάτες και οι πελάτες θα εξακολουθήσουν να έχουν πρόσβαση στα δεδομένα τους.",
          "title": "Ο λογαριασμός σου έχει απενεργοποιηθεί"
        },
        "display": "Εμφάνιση",
        "filters": "Φίλτρα",
        "generalNotifications": "Να ειδοποιούμαι για",
        "has_access_to": "Έχει πρόσβαση σε",
        "information": "Πληροφορίες προφίλ",
        "informationNotificationsEmail": "Λάβε μια επισκόπηση μέσω email, που θα περιλαμβάνει μόνο τις ειδοποιήσεις που δεν έχεις δει ακόμα στην πλατφόρμα.",
        "informationNotificationsPlatform": "Λάβε όλες τις ειδοποιήσεις στην προσωπική σου επισκόπηση πάνω δεξιά στην οθόνη",
        "informationNotificationsTitle": "Επίλεξε τι είδους ειδοποιήσεις θέλεις να λαμβάνεις και πώς",
        "its_you!": "Είσαι εσύ",
        "last_login": "Τελευταία σύνδεση",
        "maintainerAccess": "Απαιτεί πρόσβαση ανά έργο.",
        "name": "Όνομα",
        "onPlatform": "Στην πλατφόρμα",
        "ownerAccess": "Έχει πρόσβαση σε όλα τα έργα και όλο το περιεχόμενο της πλατφόρμας {client_name}.",
        "password": "Κωδικός πρόσβασης",
        "permissions": "Δικαιώματα πρόσβασης για",
        "permissionsOwnerOnly": "Ο ρόλος Διαχειριστή έργου δεν επιτρέπει αυτή την ενέργεια. Ζήτησε από ένα μέλος της ομάδας {client_name} με ρόλο Ιδιοκτήτη να το κάνει για σένα.",
        "projectMaintains": "{first_name} έχει πρόσβαση στα παρακάτω έργα:",
        "projectMaintainsAdd": "Για να δώσεις πρόσβαση, επίλεξε ένα έργο και πρόσθεσε {first_name} ως Διαχειριστή έργου στην ενότητα Πληροφορίες.",
        "projectMaintainsNone": "δεν έχει πρόσβαση σε κανένα έργο.",
        "projectNotifications": "Για το έργο",
        "search_by_name_or_email": "Αναζήτηση με όνομα ή email",
        "show_signature": "Εμφάνιση υπογραφής",
        "signature_active": "Ενεργή υπογραφή",
        "signature_info": "Αυτή η υπογραφή θα προστίθεται στις απαντήσεις που στέλνονται σε πελάτες και συνεργάτες.",
        "sorting": "Ταξινόμηση",
        "viaEmail": "Μέσω email"
      },
      "modals": {
        "maintainers_access": {
          "accessible": "Προσβάσιμο",
          "description": "Οι αλλαγές αποθηκεύονται αυτόματα",
          "not_accessible": "Μη προσβάσιμο",
          "title": "Ενημέρωση προσβασιμότητας έργου για {first_name} {last_name}"
        }
      },
      "roles": {
        "maintainer": "Διαχειριστής έργου",
        "owner": "Ιδιοκτήτης"
      },
      "toasts": {
        "create": "Το μέλος ομάδας δημιουργήθηκε",
        "update": "Το μέλος ομάδας ενημερώθηκε"
      },
      "validation": {
        "emailTaken": "Η διεύθυνση email χρησιμοποιείται ήδη",
        "mustBeEmailAddress": "Απαιτείται έγκυρη διεύθυνση email",
        "needFirstName": "Το όνομα είναι υποχρεωτικό",
        "needLastName": "Το επώνυμο είναι υποχρεωτικό",
        "requireEmailAddress": "Το email είναι υποχρεωτικό",
        "role": "Επίλεξε δικαιώματα πρόσβασης"
      }
    }
  }
}
